var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    attrs: {
      "cols": _vm.cols
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "readonly": "",
            "outlined": "",
            "dense": "",
            "disabled": _vm.disabled,
            "append-icon": _vm.removeIcon ? '' : 'mdi-calendar',
            "label": _vm.label,
            "rules": _vm.rules
          },
          model: {
            value: _vm.formattedDate,
            callback: function ($$v) {
              _vm.formattedDate = $$v;
            },
            expression: "formattedDate"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": _vm.updateDate
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }